export const UK_PILOT_SCHOOL_GROUP_ID = '68d14131a93501d6d0f1c4f2';
export const SPV2_SUPPORTED_LOCALES = ['en', 'en-ZA', 'af-ZA'];

export interface SeniorPrimaryV2GateArgs {
  schoolLocale?: string | null;
  schoolGroupId?: string | null;
}

export function shouldHideSeniorPrimaryV2({
  schoolLocale,
  schoolGroupId,
}: SeniorPrimaryV2GateArgs): boolean {
  if (schoolGroupId === UK_PILOT_SCHOOL_GROUP_ID) return true;
  if (schoolLocale && !SPV2_SUPPORTED_LOCALES.includes(schoolLocale)) return true;
  return false;
}
